import { Container, styled } from "@mui/material"

import { DASHBOARD_PADDING, FOOTER_HEIGHT, NAVBAR_HEIGHT } from "helpers/utils/constants"

export const DashboardLayoutRoot = styled(Container, {
  shouldForwardProp: (prop) => prop !== "fullWidth",
})<{ fullWidth?: boolean }>(({ fullWidth }) => ({
  flexGrow: 1,
  height: "100%",
  paddingTop: NAVBAR_HEIGHT + 20,
  ...(!fullWidth && { paddingRight: DASHBOARD_PADDING, paddingLeft: DASHBOARD_PADDING }),
  marginBottom: FOOTER_HEIGHT,
  width: "100%",
}))
